<section class="recap-page font-display">
  <div class="recap-hero">
    <div class="flex flex-col gap-2">
      <span class="text-3xl font-bold text-slate-900 sm:text-4xl">
        Final Transaction Recap
      </span>
      <span class="text-sm text-slate-500">
        Superadmin view for completed reimbursement and closed cash advance transactions.
      </span>
    </div>
    <div class="recap-hero-actions">
      <div class="recap-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          type="text"
          [formControl]="searchFormControl"
          placeholder="Search ref ID, title, employee, team, tag project, file..."
        />
      </div>
      <button type="button" class="recap-export" (click)="exportExcel()">
        <i class="fa-solid fa-file-excel"></i>
        <span>Export Excel</span>
      </button>
    </div>
  </div>

  <div class="recap-summary-section">
    <div class="recap-summary recap-summary--stats">
      <div class="recap-card">
        <span class="recap-card__label">Total Transactions</span>
        <span class="recap-card__value">{{ summary.totalTransactions }}</span>
      </div>
      <div class="recap-card">
        <span class="recap-card__label">Reimbursement</span>
        <span class="recap-card__value">{{ summary.totalReimbursements }}</span>
      </div>
      <div class="recap-card">
        <span class="recap-card__label">Cash Advance</span>
        <span class="recap-card__value">{{ summary.totalCashAdvances }}</span>
      </div>
      <div class="recap-card">
        <span class="recap-card__label">Attachments</span>
        <span class="recap-card__value">{{ summary.totalFiles }}</span>
      </div>
    </div>

    <div class="recap-summary recap-summary--money">
      <div class="recap-card recap-card--money">
        <span class="recap-card__label">Total Diajukan</span>
        <span class="recap-card__value recap-card__value--currency">
          Rp {{ summary.totalRequestedAmount | number }}
        </span>
      </div>
      <div class="recap-card recap-card--money">
        <span class="recap-card__label">Total Pengeluaran</span>
        <span class="recap-card__value recap-card__value--currency">
          Rp {{ summary.totalSpentAmount | number }}
        </span>
      </div>
      <div class="recap-card recap-card--money">
        <span class="recap-card__label">Total Sisa/Kekurangan</span>
        <span
          class="recap-card__value recap-card__value--currency"
          [ngClass]="getBalanceClass(summary.totalBalanceAmount)"
        >
          <ng-container *ngIf="summary.totalBalanceAmount !== 0">
            {{ summary.totalBalanceAmount < 0 ? '−' : '+' }}
          </ng-container>
          Rp {{ Math.abs(summary.totalBalanceAmount) | number }}
        </span>
        <span
          *ngIf="summary.totalBalanceAmount !== 0"
          class="recap-card__hint"
          [ngClass]="getBalanceClass(summary.totalBalanceAmount)"
        >
          {{ summary.totalBalanceAmount < 0 ? 'Kekurangan' : 'Sisa' }}
        </span>
      </div>
    </div>
  </div>

  <div class="recap-table-wrap">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0 min-w-max w-full font-display"
    >
      <ng-container matColumnDef="refId">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Ref ID</th>
        <td mat-cell *matCellDef="let element">
          <span class="inline-flex rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900">
            {{ element.refId || '-' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Title</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex min-w-[180px] flex-col">
            <span class="font-semibold text-slate-800">{{ element.title || '-' }}</span>
            <span class="text-xs text-slate-500">{{ element.expenseCategoryName || '-' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="typeData">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Type</th>
        <td mat-cell *matCellDef="let element">
          <span class="inline-flex rounded-full px-3 py-1 text-xs font-semibold" [ngClass]="getTypeClass(element.typeData)">
            {{ element.typeData }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="employeeName">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Employee</th>
        <td mat-cell *matCellDef="let element">{{ element.employeeName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="teamName">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Team</th>
        <td mat-cell *matCellDef="let element">{{ element.teamName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="tagProjectName">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Tag Project</th>
        <td mat-cell *matCellDef="let element">{{ element.tagProjectName || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="inline-flex rounded-full px-3 py-1 text-xs font-semibold" [ngClass]="getStatusClass(element.status)">
            {{ element.status || '-' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="transactionDate">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Transaction Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.transactionDate ? (element.transactionDate | date : 'd MMM y' : '+0700') : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="completedAt">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Completed At</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex min-w-[120px] flex-col">
            <span>{{ element.completedAt ? (element.completedAt | date : 'd MMM y' : '+0700') : '-' }}</span>
            <span class="text-xs text-slate-500">
              {{ element.completedAt ? (element.completedAt | date : 'HH:mm' : '+0700') : '-' }} WIB
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="requestedAmount">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Diajukan</th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          {{ element.currency || 'Rp' }} {{ element.requestedAmount | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="spentAmount">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Pengeluaran</th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          {{ element.currency || 'Rp' }} {{ element.spentAmount | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="balanceAmount">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Sisa/Kekurangan</th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          <ng-container *ngIf="hasBalance(element); else noBalance">
            <span [ngClass]="getBalanceClass(element.balanceAmount)">
              {{ element.currency || 'Rp' }} {{ Math.abs(element.balanceAmount) | number }}
              <span *ngIf="element.balanceAmount !== 0" class="text-xs">
                {{ element.balanceAmount < 0 ? '-' : '+' }}
              </span>
            </span>
          </ng-container>
          <ng-template #noBalance>
            <span class="text-slate-400">-</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="files">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-sm sm:text-base whitespace-nowrap">Attachments</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.files?.length; else noFiles" class="file-stack">
            <div *ngFor="let file of element.files" class="file-chip">
              <div class="flex min-w-0 flex-col">
                <span class="truncate font-medium text-slate-700">{{ file.fileName }}</span>
                <span class="text-[11px] text-slate-500">{{ file.fileType }}</span>
              </div>
              <div class="flex items-center gap-1">
                <button type="button" class="file-action" (click)="previewFile(file)">
                  <i class="fa-solid fa-eye"></i>
                </button>
                <button type="button" class="file-action" (click)="downloadFile(file)">
                  <i class="fa-solid fa-download"></i>
                </button>
              </div>
            </div>
          </div>
          <ng-template #noFiles>
            <span class="text-slate-400">-</span>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div class="flex flex-col items-center justify-center gap-2 py-10 text-center font-display">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400">
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700">No final transactions found</span>
            <span class="text-xs text-slate-500">Try adjusting the search keyword.</span>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [length]="dataTotal"
    [pageSize]="q.limit"
    [pageSizeOptions]="pageSizeOption"
    (page)="onPageChange($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</section>
